// extracted by mini-css-extract-plugin
module.exports = {"container":"tVxVQ1gE3cAkdOsytSOIT","icon":"_2BIwruKwBFhJWDPrMH_-27"};